import { gql } from "@apollo/client";

export const CREATE_NOTE = gql`
  mutation boardNoteCreate($boardID: ID!, $title: String!, $body: String!) {
    boardNoteCreate(boardID: $boardID, title: $title, body: $body) {
      body
      createdAt
      id
      title
      updatedAt
    }
  }
`;

export const UPDATE_NOTE = gql`
  mutation boardNoteUpdate($id: ID!, $title: String!, $body: String!) {
    boardNoteUpdate(id: $id, title: $title, body: $body) {
      body
      createdAt
      id
      title
      updatedAt
    }
  }
`;

export const DELETE_NOTE = gql`
  mutation boarNoteDelete($id: ID!) {
    boardNoteDelete(id: $id) {
      id
    }
  }
`;
